export default __webpack_public_path__ + "static/media/instagram.9eaf5a60.svg";